/* eslint-disable no-trailing-spaces */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable consistent-return */
/* eslint-disable no-lonely-if */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable indent */
import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from 'react';

import { useHistory, useParams, Link } from 'react-router-dom';

import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { AiOutlineFileDone } from 'react-icons/ai';
import { HiDownload } from 'react-icons/hi';
import { MdFilterList, MdSearch, MdCreditCard, MdBlock } from 'react-icons/md';
import * as Yup from 'yup';
import DownLoadFile from '../../utils/DownLoadFile';
import Input from '../../components/Input';
import Button from '../../components/Button';
import LoaderModal from '../../components/LoaderModal';
import CardCardsTable from './Components/CardTable';
import FiltersModal from './Components/FiltersModal';
import ModalBlock from './Components/ModalBlock';
import { TicketCards, TicketCard, ArrayFilters } from '../../interfaces/ticket';
import TicketService from '../../services/ticket';
import { formatPrice } from '../../services/currency';
import { useToast } from '../../hooks/toast';
import Modal from '../../components/Modal';
import { Row, Column, IconContainer } from '../../styles/components';
import AuthService from '../../services/auth';
import ConverArrayBufferToData from '../../utils/ConverArrayBufferToData';
import {
  Container,
  Title,
  ButtonsContainer,
  StatusRow,
  FiltersContainer,
  Block,
  FormWrapper,
  LinkModal,
  ModalContent,
  ModalContentBanner,
} from './styles';
import getValidationErrors from '../../utils/getValidationErrors';
import { ButtonReCaptcha } from '../../components/ButtonReCaptcha';

interface DetailParams {
  CrtCodIdentifExt: string;
}

const Cards: React.FC = () => {
  const services = { TicketService: new TicketService() };
  const formRef = useRef<FormHandles>(null);
  const formRefRelatorio = useRef<FormHandles>(null);
  const { CrtCodIdentifExt } = useParams<DetailParams>();
  const [loading, setLoading] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [dataFilters, setDataFilters] = useState<any>();
  const [status, setStatus] = useState<string>();
  const [links, setLinks] = useState<string>();
  const [balance, setBalance] = useState<string>();
  const [showModalBlock, setShowModalBlock] = useState<boolean>(false);
  const [showDuplicateLetter, setShowDuplicateLetter] =
    useState<boolean>(false);
  const [page, setpage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(30);
  const [cardNumber, setCardNumber] = useState<string>('');
  const [responsible, setResponsible] = useState<string>('');
  const [dataBloqueio, setDataBloqueio] = useState<string>('');
  const [totalRows, setTotalRows] = useState<number>(0);
  const { addToast } = useToast();
  const { goBack } = useHistory();
  const { push } = useHistory();
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const formTableRef = useRef<FormHandles>(null);
  const [modalBannerRelatorios, setModalBannerRelatorios] = useState(true);
  const [totalcards, setTotalcards] = useState<TicketCards>({} as TicketCards);
  const [cardsDetail, setCardsDetail] = useState<TicketCard>({} as TicketCard);
  const [cards, setCards] = useState<TicketCards>({} as TicketCards);
  const [cardsFiltered, setCardsFiltered] = useState([]);
  const [reportType, setReportType] = useState<string>('');
  const [filters, setFilters] = useState<any | ArrayFilters>({
    filters: [{ page }, { quantity: perPage }],
  });
  const [ticket, setTicket] = useState<any>([]);
  const [modalRelatorio, setModalRelatorio] = useState<boolean>(false);
  const [titular, setTitular] = useState<any>();

  const authService = { AuthService: new AuthService() };
  const [tipoRelatorio, setTipoRelatorio] = useState<string>('');
  const schemaRelatorio = Yup.object().shape({
    email: Yup.string().required('É necessário informar o email'),
  });
  const handleGetTicket = useCallback(async () => {
    try {
      const response = await services.TicketService.getCards();
      setTicket(response.data.DadosDoCartao);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const getTicketCards = useCallback(
    async (titularParam?: any) => {
      try {
        setLoading(true);

        const usuarioAtivo = titularParam || titular;

        console.log('Usuario sendo verificado:', usuarioAtivo);

        const response = await services.TicketService.getCards(filters);

        if (usuarioAtivo?.Login === '67679') {
          const filteringCard = response.data?.ListaCartoes?.filter(
            (data: any) =>
              data?.DadosDoCartao?.CrtCodIdentifExt !== '06850003954295',
          );
          setCardsFiltered(filteringCard || []);

          setLoading(false);
        } else {
          setCards(response.data);
          setTotalRows(response.data.ListaCartoesTotal);
          setLoading(false);
        }
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    },
    // 3. CORREÇÃO: Removi 'cards' das dependências para evitar loop
    [filters, titular],
  );

  const getCardsNumber = useCallback(async () => {
    try {
      const response = await services.TicketService.getCards();
      setTotalcards(response.data);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const getTitular = useCallback(async () => {
    try {
      setLoading(true);
      const response = await authService.AuthService.getTitular();
      console.log(response?.data);
      await setTitular(response?.data?.DadosDoTitular);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }, []);

  useEffect(() => {
    if (titular) {
      getTicketCards(titular);
    }
  }, [page, perPage, filters, titular, getTicketCards]);

  const handleChangePerPage = useCallback(
    async (newPage: number) => {
      setpage(newPage);
      setFilters({ filters: [...filters.filters, { page: newPage }] });
    },
    [filters],
  );

  const getCards = useCallback(async () => {
    const response = await services.TicketService.getCardsDetail(
      { filters: [{ ticket_vt_code: CrtCodIdentifExt }] },
      CrtCodIdentifExt,
    );
    setCardsDetail(response.data.DadosDoCartao);
  }, []);
  useEffect(() => {
    getCards();
    getTitular();
    getCardsNumber();
  }, []);

  const handleReportAsync = useCallback(
    async (type: string, Email: string) => {
      try {
        setLoadingModal(true);
        const reportFilters = {
          filters: [
            {
              'file-type': type === 'csv' ? 'C' : 'P',
              email: Email,
              user: titular.IdentificadorTitular,
              async: true,
            },
          ],
        };

        const response = await services.TicketService.getTicketReportTicket(
          reportFilters,
          type,
        );

        addToast({
          type: 'success',
          title:
            'Recebemos sua solicitação, em até 24 horas você receberá o arquivo solicitado por e-mail.',
        });

        setLoadingModal(false);
      } catch (err: any) {
        setLoadingModal(false);
        const { ...error } = err;
        console.error(error);
        const errorResponse: any = ConverArrayBufferToData(error.response.data);
        if (errorResponse.message) {
          addToast({
            type: 'error',
            title: `${errorResponse.message}`,
            description: `${errorResponse.sub_message}`,
          });
        }
        if (errorResponse.Summary) {
          addToast({
            type: 'error',
            title: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
            description: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
          });
        }
        if (error.response.data.Summary) {
          addToast({
            type: 'error',
            title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
            description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
          });
        }
      }
    },
    [titular],
  );

  function relatorio() {
    push('/agendado');
  }

  const handleSubmitRelatorio = useCallback(
    async (data: any) => {
      try {
        formRefRelatorio.current?.setErrors({});
        await schemaRelatorio.validate(data, {
          abortEarly: false,
        });
        setLoading(true);
        const response = await handleReportAsync(tipoRelatorio, data.email);
        setLoading(false);
      } catch (err: any) {
        const { ...error } = err;
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRefRelatorio.current?.setErrors(errors);
        }
      }
    },
    [tipoRelatorio, titular],
  );
  const getResponsible = useCallback((name: any) => {
    setResponsible(name);
  }, []);

  const getDataBloqueio = useCallback((dataBloqueio: any) => {
    setDataBloqueio(dataBloqueio);
  }, []);

  const handleChangeRowsPerPage = useCallback(
    async (newPerPage: number, OldPerPage: number) => {
      setPerPage(newPerPage);
      setpage(OldPerPage);
      setFilters({
        filters: [
          ...filters.filters,
          { page: OldPerPage },
          { quantity: newPerPage },
        ],
      });
    },
    [filters],
  );

  const handleApplyFilter = useCallback(
    (filtersOptions: any) => {
      setFilters({
        filters: [
          ...filters.filters,
          filtersOptions.associado !== ''
            ? {
                'link-employees': filtersOptions.associado,
              }
            : {},
          filtersOptions.saldo !== ''
            ? {
                balance: filtersOptions.saldo,
              }
            : {},
          filtersOptions.status !== ''
            ? {
                status: filtersOptions.status,
              }
            : {},
        ],
      });
      setShowModal(false);
      setShowModalBlock(false);
      setShowDuplicateLetter(false);
    },
    [filters],
  );
  useEffect(() => {
    // filters.filters.map(e => setStatus(e.status));
    // filters.filters.map(e => setLinks(e.'link-employees'));
    // filters.filters.map(e => setBalance(e.balance));

    // setStatus(filters?.filters?.map(x => x.status));
    // setLinks(filters.filters.status);
    // setBalance(filters.filters.status);
    console.log(dataFilters);
  });

  const handleClearFilters = useCallback(() => {
    localStorage.removeItem('DataFilter');
    setFilters({
      filters: [{ page }, { quantity: perPage }],
    });
  }, []);

  const handleNumberCardFilter = useCallback(
    (data: any) => {
      const isOnlyNumber = !isNaN(data.search);

      setFilters({
        filters: [
          ...filters.filters,
          isOnlyNumber
            ? {
                'code-ident-ext': data.search,
              }
            : {
                'name-employee': data.search,
              },
        ],
      });
    },
    [filters],
  );

  const RelatorioAgendado = useCallback(async (type: string) => {
    const data = localStorage.getItem('DataFilter');

    const dataparse = data ? JSON.parse(data) : null;

    const filter: any = [];
    if (!dataparse) {
      if (type) {
        filter.push({ 'file-type': type === 'csv' ? 'C' : 'P' });
      }
    } else {
      if (type) {
        filter.push({ 'file-type': type === 'csv' ? 'C' : 'P' });
      }
      if (dataparse?.associado !== '') {
        if (dataparse?.associado === 'S') {
          filter.push({ link: 'true' });
        } else {
          filter.push({ link: 'false' });
        }
      }
      if (dataparse?.status !== '') {
        filter.push({ status: dataparse?.status });
      }
      if (dataparse?.saldo) {
        filter.push({ balance: dataparse?.saldo });
      }
    }

    const reportFilters = {
      filters: filter,
    };
    try {
      const response = await services.TicketService.getTicketReportTicket(
        reportFilters,
        type,
      );

      localStorage.removeItem('DataFilter');
    } catch (err: any) {
      localStorage.removeItem('DataFilter');
      const { ...error } = err;
      console.error(error);
    }
  }, []);

  const RelatorioAgendadoAnalitico = useCallback(async (type: string) => {
    const data = localStorage.getItem('DataFilter');

    const dataparse = data ? JSON.parse(data) : null;

    const filter: any = [];
    if (!dataparse) {
      if (type) {
        filter.push({ 'file-type': type === 'csv' ? 'C' : 'P' });
      }
    } else {
      if (type) {
        filter.push({ 'file-type': type === 'csv' ? 'C' : 'P' });
      }
      if (dataparse?.associado !== '') {
        filter.push({ link: dataparse?.associado });
      }
      if (dataparse?.status !== '') {
        filter.push({ status: dataparse?.status });
      }
      if (dataparse?.saldo) {
        filter.push({ balance: dataparse?.saldo });
      }
    }
    const reportFilters = {
      filters: filter,
    };
    try {
      const response = await services.TicketService.getTicketReportBalance(
        reportFilters,
        type,
      );
    } catch (err: any) {
      const { ...error } = err;

      try {
        const errorResponse: any = ConverArrayBufferToData(error.response.data);
        if (errorResponse.message) {
          addToast({
            type: 'error',
            title: `${errorResponse.message}`,
          });
        }
        if (errorResponse.Summary) {
          addToast({
            type: 'error',
            title: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
            description: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
          });
        }
        if (error.response.data.Summary) {
          addToast({
            type: 'error',
            title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
            description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
          });
        }
        localStorage.removeItem('DataFilter');
      } catch {
        localStorage.removeItem('DataFilter');
        const { ...error } = err;
        if (error.response.data.Summary) {
          addToast({
            type: 'error',
            title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
            description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
          });
        }
      }
    }
  }, []);

  const handleReport = useCallback(async (type: string, async?: boolean) => {
    const data = localStorage?.getItem('DataFilter');

    const dataparse = data ? JSON.parse(data) : null;

    const filter: any = [];
    if (!dataparse) {
      if (type) {
        filter.push({ 'file-type': type === 'csv' ? 'C' : 'P' });
      }
      if (async === false) {
        return async;
      }
    } else {
      if (type) {
        filter.push({ 'file-type': type === 'csv' ? 'C' : 'P' });
      }
      if (dataparse?.associado !== '') {
        if (dataparse?.associado === 'S') {
          filter.push({ link: 'true' });
        } else {
          filter.push({ link: 'false' });
        }
      }
      if (dataparse?.status !== '') {
        filter.push({ status: dataparse?.status });
      }
      if (dataparse?.saldo) {
        filter.push({ balance: dataparse?.saldo });
      }
      if (async === false) {
        return async;
      }
    }

    const reportFilters = {
      filters: filter,
    };
    try {
      setLoadingModal(true);
      const response = await services.TicketService.getTicketReportTicket(
        reportFilters,
        type,
      );
      DownLoadFile(response.data, `cartões.${type}`);
      setLoadingModal(false);
      localStorage.removeItem('DataFilter');
    } catch (err: any) {
      localStorage.removeItem('DataFilter');
      setLoadingModal(false);
      const { ...error } = err;
      if (
        error.response.status === 500 ||
        error.response.status === 504 ||
        error.response.status === 503
      ) {
        addToast({
          type: 'error',
          title: 'Erro interno do servidor',
          description: 'Contacte a administração do site',
        });
      } else {
        addToast({
          type: 'error',
          title: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}`,
          description: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`,
        });
      }
      console.error(error);
    }
  }, []);

  const openModalCSV = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('csv');
    RelatorioAgendado('csv');
  }, []);

  const openModalPDF = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('pdf');
    RelatorioAgendado('pdf');
  }, []);

  const handleReportBalance = useCallback(
    async (type: string, async?: boolean) => {
      const data = localStorage.getItem('DataFilter');

      const dataparse = data ? JSON.parse(data) : null;

      const filter: any = [];
      if (!dataparse) {
        if (type) {
          filter.push({ 'file-type': type === 'csv' ? 'C' : 'P' });
        }
        if (async === false) {
          return async;
        }
      } else {
        if (type) {
          filter.push({ 'file-type': type === 'csv' ? 'C' : 'P' });
        }
        if (dataparse?.associado !== '') {
          filter.push({ link: dataparse?.associado });
        }
        if (dataparse?.status !== '') {
          filter.push({ status: dataparse?.status });
        }
        if (dataparse?.saldo) {
          filter.push({ balance: dataparse?.saldo });
        }
        if (async === false) {
          return async;
        }
      }

      const reportFilters = {
        filters: filter,
      };
      try {
        setLoadingModal(true);
        const response = await services.TicketService.getTicketReportBalance(
          reportFilters,
          type,
        );
        DownLoadFile(response.data, `saldo.${type}`);
        setLoadingModal(false);
        localStorage.removeItem('DataFilter');
      } catch (err: any) {
        localStorage.removeItem('DataFilter');
        setLoadingModal(false);
        const { ...error } = err;

        try {
          const errorResponse: any = ConverArrayBufferToData(
            error.response.data,
          );
          if (errorResponse.message) {
            addToast({
              type: 'error',
              title: `${errorResponse.message}`,
            });
          }
          if (errorResponse.Summary) {
            addToast({
              type: 'error',
              title: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
              description: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
            });
          }
          if (error.response.data.Summary) {
            addToast({
              type: 'error',
              title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
              description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
            });
          }
        } catch {
          const { ...error } = err;
          if (
            error.response.status === 500 ||
            error.response.status === 504 ||
            error.response.status === 503
          ) {
            addToast({
              type: 'error',
              title: 'Erro interno do servidor',
              description: 'Contacte a administração do site',
            });
          } else {
            addToast({
              type: 'error',
              title: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}`,
              description: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`,
            });
          }
          if (error.response.data.Summary) {
            addToast({
              type: 'error',
              title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
              description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
            });
          }
        }
      }
    },
    [filters],
  );
  const openModalCSVANALITICO = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('csv');
    RelatorioAgendadoAnalitico('csv');
  }, []);

  const openModalPDFANALITICO = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('pdf');
    RelatorioAgendadoAnalitico('pdf');
  }, []);
  const getStatusText = useCallback((status: any) => {
    const statusOptions: any = {
      A: 'ATIVO',
      I: 'INATIVO',
      B: 'BLOQUEADO',
    };
    return statusOptions[status];
  }, []);

  const handleShowModalDuplicateLetter = useCallback(
    (codCard: string, dataBloqueio: string) => {
      setResponsible('');
      setCardNumber(codCard);
      setDataBloqueio(dataBloqueio);
      setShowDuplicateLetter(true);
    },
    [],
  );

  return (
    <Container>
      <Row className="titleWrapper">
        <Column small="1" medium="1" large="1">
          <IconContainer align="center">
            <MdCreditCard />
          </IconContainer>
        </Column>
        <Column small="10" medium="10" large="10" className="TitleContainer">
          <Title>Meus Cartões</Title>
        </Column>
      </Row>
      <FiltersContainer>
        <div className="filter">
          <Button
            color="aside-background"
            padding="1"
            textBlack
            type="button"
            className="pdf"
            onClick={() => setShowModal(true)}
          >
            <MdFilterList />
            FILTROS
          </Button>
        </div>
        <div className="search">
          <Form ref={formRef} onSubmit={handleNumberCardFilter}>
            <Input
              id="search"
              name="search"
              type="text"
              placeholder="Busca por número ou nome do funcionário"
            />
            <Button
              color="orange"
              padding="1"
              type="submit"
              className="searchButton"
            >
              <MdSearch size={20} />
            </Button>
          </Form>
        </div>
        <div className="buttonsContainer">
          <Button
            color="purple"
            padding="1"
            type="button"
            className="clearFilters"
            onClick={handleClearFilters}
          >
            <MdFilterList />
            LIMPAR FILTROS
          </Button>
        </div>
      </FiltersContainer>
      <ButtonsContainer>
        <div className="buttonsInitial">
          {titular?.SelectedClient && (
            <ButtonReCaptcha
              disabled={titular?.BalanceView}
              onClick={async (data: any, cb: any) => {
                if (titular.BalanceView === true) {
                  if (titular.AsyncReport === true) {
                    if (cards.ListaCartoesTotal > 290) {
                      openModalCSVANALITICO();
                    } else {
                      await handleReportBalance('csv', false);
                    }
                  } else {
                    await handleReportBalance('csv');
                  }
                } else {
                  if (titular.AsyncReport === true) {
                    openModalCSVANALITICO();
                  } else {
                    await handleReportBalance('csv');
                  }
                }
                cb();
              }}
              modalTitle="SALDO ANALÍTICO CSV"
              component={({ handle }) => (
                <Button
                  color="purple"
                  padding="0"
                  type="button"
                  onClick={() => handle()}
                  className="saldo"
                >
                  <HiDownload />
                  SALDO ANALÍTICO CSV
                </Button>
              )}
            />
          )}
          {titular?.SelectedClient && (
            <ButtonReCaptcha
              disabled={titular?.BalanceView}
              onClick={async (data: any, cb: any) => {
                if (titular.BalanceView === true) {
                  if (titular.AsyncReport === true) {
                    if (cards.ListaCartoesTotal > 290) {
                      openModalPDFANALITICO();
                    } else {
                      await handleReportBalance('pdf', false);
                    }
                  } else {
                    await handleReportBalance('pdf');
                  }
                } else {
                  if (titular.AsyncReport === true) {
                    openModalPDFANALITICO();
                  } else {
                    await handleReportBalance('pdf');
                  }
                }
                cb();
              }}
              modalTitle="SALDO ANALÍTICO PDF"
              component={({ handle }) => (
                <Button
                  color="purple"
                  padding="0"
                  type="button"
                  className="saldo"
                  onClick={() => handle()}
                >
                  <HiDownload />
                  SALDO ANALÍTICO PDF
                </Button>
              )}
            />
          )}
          <ButtonReCaptcha
            disabled={titular?.BalanceView}
            onClick={async (data: any, cb: any) => {
              if (titular.BalanceView === true) {
                if (titular.AsyncReport === true) {
                  if (cards.ListaCartoesTotal > 290) {
                    openModalCSV();
                  } else {
                    await handleReport('csv', false);
                  }
                } else {
                  await handleReport('csv');
                }
              } else {
                if (titular.AsyncReport === true) {
                  openModalCSV();
                } else {
                  await handleReport('csv');
                }
              }
              cb();
            }}
            modalTitle="SALDO SINTÉTICO CSV"
            component={({ handle }) => (
              <Button
                color="purple"
                padding="0"
                type="button"
                className="csv"
                onClick={() => handle()}
              >
                <HiDownload />
                SALDO SINTÉTICO CSV
              </Button>
            )}
          />
          <ButtonReCaptcha
            disabled={titular?.BalanceView}
            modalTitle="SALDO SINTÉTICO PDF"
            onClick={async (data: any, cb: any) => {
              if (titular.BalanceView === true) {
                if (titular.AsyncReport === true) {
                  if (cards.ListaCartoesTotal > 290) {
                    openModalPDF();
                  } else {
                    await handleReport('pdf', false);
                  }
                } else {
                  await handleReport('pdf');
                }
              } else {
                if (titular.AsyncReport === true) {
                  openModalPDF();
                } else {
                  await handleReport('pdf');
                }
              }
              cb();
            }}
            component={({ handle }) => (
              <Button
                color="purple"
                padding="0"
                type="button"
                className="pdf"
                onClick={() => handle()}
              >
                <HiDownload />
                SALDO SINTÉTICO PDF
              </Button>
            )}
          />
        </div>
      </ButtonsContainer>
      <CardCardsTable
        data={titular?.Login === '67679' ? cardsFiltered : cards?.ListaCartoes}
        columns={[
          {
            name: 'Cartão VT',
            selector: 'DadosDoCartao.CrtCodIdentifExt',
            cell: ({ DadosDoCartao }: any) => (
              <Link
                to={`/cartoes/${DadosDoCartao.CrtCodIdentifExt}`}
                style={{
                  textDecoration: 'underline',
                  textUnderlinePosition: 'under',
                }}
              >
                {DadosDoCartao.CrtCodIdentifExt}
              </Link>
            ),
          },
          {
            name: 'Funcionário',
            selector: 'DadosDoCartao.Funcionario.Nome',
            cell: ({ DadosDoCartao }: any) => (
              <p>
                {DadosDoCartao.Funcionario.Nome}
                {!DadosDoCartao.Funcionario.Nome && <span>-</span>}
              </p>
            ),
          },
          {
            name: 'Saldo',
            selector: 'DadosDoCartao.Saldo',
            cell: ({ DadosDoCartao }: any) => (
              <p>{formatPrice(DadosDoCartao.Saldo)}</p>
            ),
          },
          {
            name: 'Status',
            center: true,
            selector: 'DadosDoCartao.Status',
            cell: ({ DadosDoCartao }: any) => (
              <StatusRow status={DadosDoCartao.Status}>
                {getStatusText(DadosDoCartao.Status)}
              </StatusRow>
            ),
          },
          {
            name: 'Ações',
            selector: 'DadosDoCartao.Status',
            cell: ({ DadosDoCartao }: any) => (
              <Block>
                {DadosDoCartao.Status === 'B' ? (
                  ''
                ) : (
                  <Button
                    color="red"
                    title="Bloquear Cartão"
                    padding="1"
                    type="button"
                    onClick={() => {
                      setCardNumber(DadosDoCartao.CrtCodIdentifExt);
                      setDataBloqueio(DadosDoCartao.DataBloqueio);
                      setShowModalBlock(true);
                    }}
                  >
                    <MdBlock size={30} />
                  </Button>
                )}
                {DadosDoCartao.Status === 'B' && (
                  <Button
                    color="purple"
                    title="Carta de autorização de retirada"
                    padding="1"
                    type="button"
                    onClick={() => {
                      handleShowModalDuplicateLetter(
                        DadosDoCartao.CrtCodIdentifExt,
                        DadosDoCartao.DataBloqueio,
                      );
                    }}
                  >
                    <AiOutlineFileDone size={30} style={{ color: '#3F1159' }} />
                  </Button>
                )}
              </Block>
            ),
          },
        ].filter((column: any) => {
          if (column?.name === 'Saldo') {
            if (titular?.BalanceView) {
              return true;
            }
            return false;
          }
          return true;
        })}
        loading={loading}
        totalRows={totalRows}
        onChangePage={handleChangePerPage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        emptyText="Nenhum Cartão"
      />
      {showModal && (
        <FiltersModal
          filters={filters}
          handleClose={() => setShowModal(false)}
          handleApplyFilter={handleApplyFilter}
          show={showModal}
          title="Filtros"
        />
      )}
      {showModalBlock && (
        <ModalBlock
          cardNumber={cardNumber}
          dataBloqueio={dataBloqueio}
          title="Bloqueio de cartão"
          text={`Tem certeza de que deseja bloquear o cartão ${cardNumber}? (Essa ação não pode ser desfeita.)`}
          show={showModalBlock}
          setShowDuplicateLetter={setShowDuplicateLetter}
          getDataBloqueio={getDataBloqueio}
          getResponsible={getResponsible}
          handleClose={() => setShowModalBlock(false)}
          handleSuccess={getTicketCards}
        />
      )}
      {modalRelatorio && (
        <Modal
          handleClose={() => setModalRelatorio(false)}
          show={modalRelatorio}
          title="Agendamento de Relatório"
        >
          <ModalContent>
            <Form ref={formRefRelatorio} onSubmit={handleSubmitRelatorio}>
              <FormWrapper>
                <p>Estamos processando os dados do pedido do Relatório.</p>
                <p>
                  <LinkModal onClick={relatorio}>Clique Aqui!</LinkModal>
                  Para abrir o menu Relatórios Agendados e acompanhar o Pedido
                  solicitado. Quando este processo for finalizado basta fazer o
                  download do arquivo.
                </p>
              </FormWrapper>
            </Form>
          </ModalContent>
        </Modal>
      )}
      {/* {showDuplicateLetter && (
        <ModalDuplicateLetter
          cardNumber={cardNumber}
          dataBloqueio={dataBloqueio}
          name={responsible}
          title="Carta de autorização de retirada"
          text={`Cartão ${cardNumber} bloqueado com sucesso em ${
            dataBloqueio.split(' ')[0]
          }.`}
          show={showDuplicateLetter}
          handleClose={() => setShowDuplicateLetter(false)}
          handleSuccess={getTicketCards}
        />
      )} */}
      {showDuplicateLetter && (
        <Modal
          handleClose={() => setShowDuplicateLetter(false)}
          show={showDuplicateLetter}
          title="Carta de autorização de retirada"
        >
          <FormWrapper>
            <p className="bloqueados">
              Acesse o menu
              <a href="/cartoes-bloqueados-sem-2via"> Bloqueados Sem 2ª Via </a>
              para emitir a Carta de Autorização de Retirada.
            </p>
          </FormWrapper>
        </Modal>
      )}
      {loadingModal && (
        <LoaderModal
          title="Carregando"
          show={loadingModal}
          handleClose={() => setLoadingModal(false)}
        />
      )}

      {modalBannerRelatorios && (
        <Modal
          handleClose={() => setModalBannerRelatorios(false)}
          show={modalBannerRelatorios}
          title="Relatórios Agendados"
        >
          <ModalContentBanner>
            <p>
              Para manter o funcionamento e performance da nossa plataforma os
              relatórios Analítico e Sintético agora serão agendados.
            </p>
            <p>
              Os relatórios deverão ser solicitados como de costume, e dentro do
              menu Relatórios, sub-menu{' '}
              <LinkModal onClick={relatorio}>Relatórios Agendados</LinkModal>
              que se encontra no lado esquerdo da tela, os mesmos poderão ser
              acompanhados e posteriormente baixados.
            </p>
          </ModalContentBanner>
        </Modal>
      )}
    </Container>
  );
};

export default Cards;
